module.exports = __webpack_public_path__ + "e604c93d566e1ffb5d453aa37a97de08.jpg";